import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from 'react-alert';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../../utils/permissionAuth';
import { useNavigate } from 'react-router-dom';
import xlsx from 'json-as-xlsx';
import Page from 'src/components/Page';
import { Box, Button, Card, CardContent, CardHeader, Container, Grid, InputLabel, makeStyles, MenuItem, TextField, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TablePagination } from '@material-ui/core';
import { Formik } from 'formik';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { LoadingComponent } from 'src/utils/newLoader';
import tokenService from '../../../../utils/tokenDecoder';
import services from '../Services';
import * as Yup from 'yup';
import ReactToPrint from 'react-to-print';
import moment from 'moment';
import CreatePDF from './CreatePDF';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: 'red'
  },
  colorRecord: {
    backgroundColor: 'green'
  }
}));

const screenCode = 'FESTIVALADVANCEDETAILREPORT';

export default function FestivalAdvanceDetailReport() {
  const alert = useAlert();
  const navigate = useNavigate();
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState();
  const [fromDate, handleFromDate] = useState(new Date());
  const [toDate, handleToDate] = useState(new Date());
  const [RouteList, setRouteList] = useState([]);
  const [responseData, setresponseData] = useState([]);
  const [csvHeaders, SetCsvHeaders] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [title, setTitle] = useState('Festival Advance Detail Report');
  const [IsReportVisible, setIsReportVisible] = useState(false);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    registrationNumber: '',
    fromDate: moment(new Date()).format('YYYY-MM-DD'),
    toDate: moment(new Date()).format('YYYY-MM-DD'),
  });
  const componentRef = useRef();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isProfitAndLossConfigurationEnabled: false
  });

  useEffect(() => {
    trackPromise(getPermission());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getFactoriesForDropDown());
    setSelectedSearchValues({
      ...selectedSearchValues,
      factoryID: 0,
      routeID: 0,
    });
  }, [selectedSearchValues.groupID]);

  useEffect(() => {
    trackPromise(
      getRouteForDropdown());
    setSelectedSearchValues({
      ...selectedSearchValues,
      routeID: 0,
    });
  }, [selectedSearchValues.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'VIEWFESTIVALADVANCEDETAILREPORT'
    );
    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setSelectedSearchValues({
      ...selectedSearchValues,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropDown() {
    const factory = await services.getFactoryByGroupID(
      selectedSearchValues.groupID
    );
    setFactoryList(factory);
  }

  async function getRouteForDropdown() {
    const routes = await services.getRoutesForDropDown(selectedSearchValues.factoryID);
    setRouteList(routes);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  async function handleSearch() {
    if (selectedSearchValues.registrationNumber != '' && !/^\d+$/.test(selectedSearchValues.registrationNumber)) {
      alert.error('INVALID REGISTRATION NUMBER');
      return;
    }
    let model = {
      groupID: selectedSearchValues.groupID,
      factoryID: selectedSearchValues.factoryID,
      fromDate: moment(fromDate).format('YYYY-MM-DD'),
      toDate: moment(toDate).format('YYYY-MM-DD')
    };
    if (selectedSearchValues.routeID !== 0 && selectedSearchValues.routeID !== "0") {
      model.routeID = parseInt(selectedSearchValues.routeID);
    }

    if (selectedSearchValues.registrationNumber !== '') {
      model.regNumber = parseInt(selectedSearchValues.registrationNumber);
    }
    let response = await services.getFestivalAdvacneDetailReport(model);
    setresponseData(response.data);
    if (response.data.length > 0) {
      setIsReportVisible(true);
    } else {
      setIsReportVisible(false);
      alert.error('NO RECORDS TO DISPLAY');
    }
    model = {};
    setPage(0);
  }

  const reportData = responseData.map(row => ({
    ...row,
    routeName: RouteList[row.routeID],
    amount: row.amount.toFixed(2),
    requestedDate: moment(row.requestedDate).format('DD-MM-YYYY'),
    approvedDate: moment(row.approvedDate).format('DD-MM-YYYY')
  }));
  const totalAmount = reportData.reduce((sum, row) => sum + Number(row.amount), 0);

  function handleChange(e) {
    const target = e.target;
    const value = target.value;
    setSelectedSearchValues({
      ...selectedSearchValues,
      [e.target.name]: value
    });
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    );
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          'Route': String(x.routeName),
          'Reg No': String(x.regNumber),
          'Name': String(x.fullName),
          'Payment Effective Month': String(x.effectiveMonth),
          'No. of Installment': String(x.numberOfInstallment),
          'Approved Date': String(x.approvedDate),
          'Requested Date': String(x.requestedDate),
          'Amount': Number(x.amount)
        }
        res.push(vr);
      });
      var vr = {
        'Route': "Total",
        'Amount': Number(totalAmount)
      }
      res.push(vr);
      res.push({});

      var vr = {
        'Route': "Group: " + GroupList[selectedSearchValues.groupID],
        'Reg No': "Factory: " + FactoryList[selectedSearchValues.factoryID]
      }
      res.push(vr);

      var vr = {
        'Route': "Route: " + (selectedSearchValues.routeID == 0 || selectedSearchValues.routeID == "0" ? "All Routes" : RouteList[selectedSearchValues.routeID]),
        'Reg No': "Reg No: " + (selectedSearchValues.registrationNumber === '' || selectedSearchValues.registrationNumber === null ? "All Registration Numbers" : selectedSearchValues.registrationNumber)
      }
      res.push(vr);

      var vr = {
        'Route': "From Date: " + moment(fromDate).format('DD-MM-YYYY'),
        'Reg No': "To Date: " + moment(toDate).format('DD-MM-YYYY')
      }
      res.push(vr);
    }
    return res;
  }

  async function createExcellFile() {
    var file = await createDataForExcel(reportData);
    var settings = {
      sheetName: 'Festiveal Advance Detail Report',
      fileName:
        'Festiveal Advance Detail Report - ' +
        (GroupList[selectedSearchValues.groupID] || '') + ' - ' +
        (FactoryList[selectedSearchValues.factoryID] || '') + ' - ' +
        ((selectedSearchValues.routeID === 0 || selectedSearchValues.routeID === "0") ? 'All Routes' : RouteList[selectedSearchValues.routeID]) + ' - ' +
        ((selectedSearchValues.registrationNumber === '' || selectedSearchValues.registrationNumber === null) ? 'All Reg No' : 'Reg No: ' + selectedSearchValues.registrationNumber) +
        ' - From ' + moment(fromDate).format('DD-MM-YYYY') +
        ' to ' + moment(toDate).format('DD-MM-YYYY'),
    }
    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })
    let dataA = [
      {
        sheet: 'Festiveal Advance Detail Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]
    xlsx(dataA, settings);
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            background-color: white !important;
        }
        body {
            background-color: white !important;
        }
    }`;
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Card>
            <Formik
              initialValues={{
                groupID: selectedSearchValues.groupID,
                factoryID: selectedSearchValues.factoryID
              }}
              validationSchema={Yup.object().shape({
                groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
                factoryID: Yup.number().required('Estate is required').min(1, 'Estate is required')
              })}
              onSubmit={() => trackPromise(handleSearch())}
              enableReinitialize>
              {({ errors, handleBlur, handleSubmit, touched }) => (
                <form onSubmit={handleSubmit}>
                  <Box mt={0}>
                    <Card>
                      <CardHeader title={cardTitle(title)} />
                      <PerfectScrollbar>
                        <CardContent>
                          <Grid container spacing={3}>
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="groupID">
                                Group *
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.groupID && errors.groupID)}
                                fullWidth
                                helperText={touched.groupID && errors.groupID}
                                name="groupID"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={selectedSearchValues.groupID}
                                variant="outlined"
                                id="groupID"
                                size='small'
                                disabled={!permissionList.isGroupFilterEnabled}>
                                <MenuItem value="0">--Select Group--</MenuItem>
                                {generateDropDownMenu(GroupList)}
                              </TextField>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="factoryID">
                                Estate *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(touched.factoryID && errors.factoryID)}
                                fullWidth
                                helperText={touched.factoryID && errors.factoryID}
                                size="small"
                                name="factoryID"
                                onBlur={handleBlur}
                                onChange={e => {
                                  handleChange(e);
                                }}
                                value={selectedSearchValues.factoryID}
                                variant="outlined"
                                id="factoryID">
                                <MenuItem value="0">--Select Estate--</MenuItem>
                                {generateDropDownMenu(FactoryList)}
                              </TextField>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="routeID">
                                Route
                              </InputLabel>
                              <TextField select
                                error={Boolean(touched.routeID && errors.routeID)}
                                fullWidth
                                helperText={touched.routeID && errors.routeID}
                                name="routeID"
                                onBlur={handleBlur}
                                onChange={(e) => handleChange(e)}
                                value={selectedSearchValues.routeID}
                                variant="outlined"
                                id="routeID"
                                size='small'>
                                <MenuItem value="0">--Select Route--</MenuItem>
                                {generateDropDownMenu(RouteList)}
                              </TextField>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="registrationNumber">
                                Registration Number
                              </InputLabel>
                              <TextField
                                fullWidth
                                name="registrationNumber"
                                size='small'
                                onChange={(e) => handleChange(e)}
                                value={selectedSearchValues.registrationNumber}
                                variant="outlined"
                                id="registrationNumber">
                              </TextField>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>From Date *</InputLabel>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  fullWidth
                                  inputVariant="outlined"
                                  format="dd/MM/yyyy"
                                  margin="dense"
                                  name='fromDate'
                                  id='fromDate'
                                  value={fromDate}
                                  onChange={(date) => {
                                    handleFromDate(date);
                                    setSelectedSearchValues(prev => ({
                                      ...prev,
                                      fromDate: moment(date).format('YYYY-MM-DD')
                                    }));
                                  }}
                                  maxDate={toDate}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                  }}
                                  autoOk />
                              </MuiPickersUtilsProvider>
                            </Grid>
                            <Grid item md={3} xs={12}>
                              <InputLabel shrink id="date" style={{ marginBottom: '-8px' }}>To Date *</InputLabel>
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                  fullWidth
                                  inputVariant="outlined"
                                  format="dd/MM/yyyy"
                                  margin="dense"
                                  name='toDate'
                                  id='toDate'
                                  value={toDate}
                                  onChange={(date) => {
                                    handleToDate(date);
                                    setSelectedSearchValues(prev => ({
                                      ...prev,
                                      toDate: moment(date).format('YYYY-MM-DD')
                                    }));
                                  }}
                                  minDate={fromDate}
                                  maxDate={new Date()}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date',
                                  }}
                                  autoOk />
                              </MuiPickersUtilsProvider>
                            </Grid>
                          </Grid>
                          <Box display="flex" flexDirection="row-reverse" p={2}>
                            <Button
                              color="primary"
                              variant="contained"
                              size="small"
                              type="submit"
                            >
                              Search
                            </Button>
                          </Box>
                        </CardContent>
                      </PerfectScrollbar>
                    </Card>
                  </Box>
                </form>
              )}
            </Formik>
            <PerfectScrollbar>
              {IsReportVisible && (
                <Box minWidth={800}>
                  {responseData.length > 0 ?
                    <TableContainer style={{ marginTop: 16, padding: 8 }}>
                      <Table size="small" aria-label="report table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <TableHead>
                          <TableRow>
                            <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 120 }} align="center"><b>Route</b></TableCell>
                            <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 80 }} align="center"><b>Reg No</b></TableCell>
                            <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 200 }} align="center"><b>Name</b></TableCell>
                            <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 120 }} align="center"><b>Payment Effective Month</b></TableCell>
                            <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 120 }} align="center"><b>No. of Installment</b></TableCell>
                            <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 140 }} align="center"><b>Requested Date</b></TableCell>
                            <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 140 }} align="center"><b>Approved Date</b></TableCell>
                            <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 100 }} align="center"><b>Amount</b></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {reportData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, idx) => (
                            <TableRow key={idx}>
                              <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 120 }} align="left">{row.routeName}</TableCell>
                              <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 80 }} align="left">{row.regNumber}</TableCell>
                              <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 200 }} align="left">{row.fullName}</TableCell>
                              <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 120 }} align="left">{row.effectiveMonth}</TableCell>
                              <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 120 }} align="left">{row.numberOfInstallment}</TableCell>
                              <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 140 }} align="center">{row.requestedDate}</TableCell>
                              <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 140 }} align="center">{row.approvedDate}</TableCell>
                              <TableCell style={{ border: '1px solid #e0e0e0', padding: '8px', width: 100 }} align="right">{row.amount}</TableCell>
                            </TableRow>
                          ))}
                          <TableRow>
                            <TableCell colSpan={7} style={{ border: '1px solid #e0e0e0', textAlign: 'left', padding: '8px' }}>
                              <b>Total</b>
                            </TableCell>
                            <TableCell style={{ border: '1px solid #e0e0e0', textAlign: 'right', padding: '8px' }}>
                              <b>{totalAmount.toFixed(2)}</b>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 20]}
                        component="div"
                        count={reportData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage} />
                    </TableContainer> : null}
                  <Box display="flex" justifyContent="flex-end" p={2}>
                    <Button
                      color="primary"
                      id="btnRecord"
                      type="submit"
                      variant="contained"
                      style={{ marginRight: '1rem' }}
                      className={classes.colorRecord}
                      onClick={() =>
                        createExcellFile()
                      }
                      size='small'>
                      EXCEL
                    </Button>
                    <ReactToPrint
                      documentTitle={
                        'Festiveal Advance Detail Report - ' +
                        (GroupList[selectedSearchValues.groupID] || '') + ' - ' +
                        (FactoryList[selectedSearchValues.factoryID] || '') + ' - ' +
                        ((selectedSearchValues.routeID === 0 || selectedSearchValues.routeID === "0") ? 'All Routes' : RouteList[selectedSearchValues.routeID]) + ' - ' +
                        ((selectedSearchValues.registrationNumber === '' || selectedSearchValues.registrationNumber === null) ? 'All Reg No' : 'Reg No: ' + selectedSearchValues.registrationNumber) +
                        ' - From ' + moment(fromDate).format('DD-MM-YYYY') +
                        ' to ' + moment(toDate).format('DD-MM-YYYY')
                      }
                      trigger={() => (
                        <Button
                          color="primary"
                          id="btnRecord"
                          type="submit"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorCancel}
                          size='small'>
                          PDF
                        </Button>
                      )}
                      pageStyle={getPageMargins()}
                      content={() => componentRef.current} />
                    <div hidden={true}>
                      <CreatePDF
                        ref={componentRef}
                        reportData={reportData}
                        GroupList={GroupList}
                        FactoryList={FactoryList}
                        RouteList={RouteList}
                        selectedSearchValues={selectedSearchValues}
                        totalAmount={totalAmount} />
                    </div>
                  </Box>
                </Box>
              )}
            </PerfectScrollbar>
          </Card>
        </Container>
      </Page>
    </Fragment>
  );
}